import { FileItem } from "./Types";

export const createFileItem = (file: File): FileItem => ({
    name: file.name,
    text: "pending",
    status: 'pending',
    size: file.size,
    file: file
  });